import useTranslation from "next-translate/useTranslation";
import React from "react";
import formatUrl from "utils/FormatUrl";
import style from "./style.module.css";

function Ourplans(props: any) {
  const { lang } = useTranslation("");
  return (
    <div className={`${style.card} ${props.isFirst ? style.firstCard : ""}`}>
      <div className={style.divTitles}>
        <p className={style.title}>{props.title}</p>
        <p className={style.subtitle}>{props.subTitle}</p>
      </div>
      <div className={style.plans}>
        {props.planinfos?.map((item, key) => {
          return (
            <span key={key} className={style.spanElement}>
              <svg
                width="19"
                height="14"
                viewBox="0 0 19 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 7.00004L6.65685 12.6569L17.9694 1.34314"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {item.listelement[props.lang]}
            </span>
          );
        })}
      </div>
      <div className={style.button}>
        <a
          className={`${style.btnLink} ${
            props.isFirst ? style.btnLinkFirst : ""
          }`}
          href={formatUrl(props.btn_link, lang)}
          target="__blank"
        >
          {props.button_title}
        </a>
      </div>
    </div>
  );
}

export default Ourplans;
